"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChildrenPropType = exports.VerticalAlignPropType = exports.TextAlignPropType = exports.BlogPostPropType = exports.GatsbyImagePropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var GatsbyImagePropType = _propTypes["default"].shape({
  altText: _propTypes["default"].string,
  fixed: _propTypes["default"].shape({
    base64: _propTypes["default"].string,
    width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    src: _propTypes["default"].string,
    srcSet: _propTypes["default"].string
  }),
  fluid: _propTypes["default"].shape({
    base64: _propTypes["default"].string,
    width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    src: _propTypes["default"].string,
    srcSet: _propTypes["default"].string
  })
});

exports.GatsbyImagePropType = GatsbyImagePropType;

var BlogPostPropType = _propTypes["default"].shape({
  id: _propTypes["default"].number.isRequired,
  title: _propTypes["default"].string.isRequired,
  author: _propTypes["default"].string,
  slug: _propTypes["default"].string.isRequired,
  summary: _propTypes["default"].string,
  publishedAt: _propTypes["default"].string,
  heroImage: _propTypes["default"].oneOfType([_propTypes["default"].string, GatsbyImagePropType])
});

exports.BlogPostPropType = BlogPostPropType;

var TextAlignPropType = _propTypes["default"].oneOf(['left', 'center', 'right', 'justified']);

exports.TextAlignPropType = TextAlignPropType;

var VerticalAlignPropType = _propTypes["default"].oneOf(['bottom', 'middle', 'top']);

exports.VerticalAlignPropType = VerticalAlignPropType;

var ChildrenPropType = _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].element, _propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].arrayOf(_propTypes["default"].element)]);

exports.ChildrenPropType = ChildrenPropType;